import { P0, S, abs, core, max, moodK, scaleAt, sq } from '../../geometry';

export const focus = {
  name: 'Focus',
  colors: ['#161616', '#E3A008'],
  draw(m, t) {
    let s = 28 + 0.6 * S(t * 1.6),
      a = 10,
      spin = 0,
      pose = P0();
    if (m === 'happy') {
      s = 30 + 3 * abs(S(t * 7));
      spin = 6 * S(t * 6);
      pose.ty = -2 * abs(S(t * 6));
    }
    // Thinking: the frame keeps turning and refocusing.
    if (m === 'thinking') {
      s = 27 + 4 * S(t * 3);
      spin = t * 40;
    }
    if (m === 'talking') s = 28 + 2.5 * max(0, S(t * 10));
    if (m === 'surprised') {
      s = 36;
      a = 12;
    }
    if (m === 'paused') {
      s = 21;
      a = 6;
      spin = 45 + 2 * S(t * 0.5);
    }
    const corners = [
      [-1, -1],
      [1, -1],
      [1, 1],
      [-1, 1],
    ];
    return {
      strokes: corners.map(([sx, sy], i) => ({
        c: i % 2 ? 'b' : 'a',
        pts: [
          [50 + sx * s, 52 + sy * (s - a)],
          [50 + sx * s, 52 + sy * s],
          [50 + sx * (s - a), 52 + sy * s],
        ],
        sharp: true,
        n: 24,
        spin,
      })),
      eyes: { x: 50, y: 52 },
      pose,
    };
  },
  eyesOn: 'a',
  solid(f, m, t) {
    f.strokes.unshift(
      core(scaleAt(sq(50, 52, 15.5, 15.5, 4.5), 50, 52, moodK(m, t)))
    );
    return f;
  },
};
